/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unsaved_Changes_Stay_On_PageInputs */

const en_unsaved_changes_stay_on_page = /** @type {(inputs: Unsaved_Changes_Stay_On_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stay on page`)
};

const nl_unsaved_changes_stay_on_page = /** @type {(inputs: Unsaved_Changes_Stay_On_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Op pagina blijven`)
};

/**
* | output |
* | --- |
* | "Stay on page" |
*
* @param {Unsaved_Changes_Stay_On_PageInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const unsaved_changes_stay_on_page = /** @type {((inputs?: Unsaved_Changes_Stay_On_PageInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unsaved_Changes_Stay_On_PageInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_unsaved_changes_stay_on_page(inputs)
	return en_unsaved_changes_stay_on_page(inputs)
});